import { render } from "./APITutorial.vue?vue&type=template&id=6909c262"
const script = {}

import "./APITutorial.vue?vue&type=style&index=0&id=6909c262&lang=css"

import exportComponent from "/home/ubuntu/API-Frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__